export const IsomerThumbsUp = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="680"
      height="192"
      viewBox="0 0 680 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6649_120955)">
        <rect width="680" height="192" fill="#F8FAFE" />
        <path d="M393.485 34.5752L339.756 1L282.485 40" stroke="black" />
        <rect
          width="119.012"
          height="142.932"
          rx="36.68"
          transform="matrix(-1 0 0 1 399.263 31.5215)"
          fill="#2164DA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          width="95.9765"
          height="117.118"
          rx="5"
          transform="matrix(-1 0 0 1 387.746 44.5153)"
          fill="#F8FAFE"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M287.557 157.843L287.587 124.804L298.287 114.774C300.743 112.477 304.573 112.522 306.974 114.876L319.616 127.264L340.302 110.859C342.605 109.029 345.87 109.041 348.159 110.89L389.052 144.022L389.619 145.392L389.61 157.938C389.606 160.257 387.725 162.136 385.405 162.135L291.737 162.051C289.422 162.041 287.552 160.159 287.557 157.843Z"
          fill="#2164DA"
        />
        <circle
          cx="4.95749"
          cy="4.95749"
          r="4.95749"
          transform="matrix(-0.983524 0.180779 0.180779 0.983524 321.752 86)"
          fill="#2164DA"
        />
        <rect
          width="95.9765"
          height="117.118"
          rx="5"
          transform="matrix(-1 0 0 1 387.746 44.5153)"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M390.263 31.5215C395.234 31.5215 399.263 35.5509 399.263 40.5215V165.454C399.263 170.424 395.234 174.454 390.263 174.454H289.251C284.281 174.454 280.251 170.424 280.251 165.454V40.5215C280.251 35.5509 284.281 31.5215 289.251 31.5215L390.263 31.5215ZM382.746 44.5153C385.507 44.5153 387.746 46.7539 387.746 49.5153V156.633C387.746 159.395 385.507 161.633 382.746 161.633H296.769C294.008 161.633 291.769 159.395 291.769 156.633V49.5153C291.769 46.7539 294.008 44.5153 296.769 44.5153H382.746Z"
          fill="#2164DA"
        />
        <path
          d="M398.763 40.5215C398.763 35.8271 394.957 32.0215 390.263 32.0215V31.0215C395.51 31.0215 399.763 35.2748 399.763 40.5215H398.763ZM398.763 165.454V40.5215H399.763V165.454H398.763ZM390.263 173.954C394.957 173.954 398.763 170.148 398.763 165.454H399.763C399.763 170.701 395.51 174.954 390.263 174.954V173.954ZM289.251 173.954H390.263V174.954H289.251V173.954ZM280.751 165.454C280.751 170.148 284.557 173.954 289.251 173.954V174.954C284.005 174.954 279.751 170.701 279.751 165.454H280.751ZM280.751 40.5215V165.454H279.751V40.5215H280.751ZM289.251 32.0215C284.557 32.0215 280.751 35.8271 280.751 40.5215H279.751C279.751 35.2748 284.005 31.0215 289.251 31.0215V32.0215ZM390.263 32.0215H289.251V31.0215L390.263 31.0215V32.0215ZM387.246 49.5153C387.246 47.03 385.231 45.0153 382.746 45.0153V44.0153C385.783 44.0153 388.246 46.4777 388.246 49.5153H387.246ZM387.246 156.633V49.5153H388.246V156.633H387.246ZM382.746 161.133C385.231 161.133 387.246 159.118 387.246 156.633H388.246C388.246 159.671 385.783 162.133 382.746 162.133V161.133ZM296.769 161.133H382.746V162.133H296.769V161.133ZM292.269 156.633C292.269 159.118 294.284 161.133 296.769 161.133V162.133C293.732 162.133 291.269 159.671 291.269 156.633H292.269ZM292.269 49.5153V156.633H291.269V49.5153H292.269ZM296.769 45.0153C294.284 45.0153 292.269 47.03 292.269 49.5153H291.269C291.269 46.4777 293.732 44.0153 296.769 44.0153V45.0153ZM382.746 45.0153H296.769V44.0153H382.746V45.0153Z"
          fill="#272D41"
        />
        <circle
          cx="339.985"
          cy="4.5"
          r="3.5"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M414.683 79.0988L429.56 65.5445L471.84 114.045C471.84 114.045 520.34 87.906 536.18 83.8606C542.084 82.3542 524.055 123.212 524.055 123.212L492.456 137.031C476.163 143.027 457.868 137.553 447.546 123.594L414.683 79.0988Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="355.721"
          y="3"
          width="119.012"
          height="142.932"
          rx="11"
          transform="rotate(10.7748 355.721 3)"
          fill="#AA90FA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="364.606"
          y="17.918"
          width="95.9765"
          height="117.118"
          rx="5"
          transform="rotate(10.7748 364.606 17.918)"
          fill="#F8FAFE"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M390.201 131.874L399.37 83.6894"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M395.386 132.86L410.231 54.8583"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M397.792 57.8646L383.811 131.329L397.792 57.8646Z"
          fill="#2164DA"
        />
        <path
          d="M397.792 57.8646L383.811 131.329"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M431.495 93.77C424.633 92.4642 420.13 85.8431 421.435 78.9814C422.741 72.1197 429.362 67.6158 436.224 68.9216L436.611 66.886C437.056 64.5496 439.31 63.016 441.647 63.4606L444.439 63.9919"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M361.841 45.5902L371.348 47.3995C372.38 47.5951 373.292 48.193 373.883 49.0613C374.473 49.9297 374.695 50.9974 374.498 52.029L372.976 60.0236C372.779 61.0552 373 62.1229 373.591 62.9913C374.182 63.8596 375.093 64.4575 376.125 64.6531L379.366 65.2699C380.398 65.4655 381.31 66.0634 381.901 66.9317C382.491 67.8001 382.713 68.8678 382.516 69.8994L379.759 84.3819C379.564 85.4138 378.966 86.3256 378.098 86.9163C377.229 87.507 376.162 87.7282 375.13 87.5311L365.623 85.7218C364.591 85.5247 363.524 85.7459 362.655 86.3366C361.787 86.9273 361.189 87.8391 360.993 88.871C360.581 91.0143 358.51 92.4184 356.366 92.0087L353.125 91.3919"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M432.988 42.3374L432.577 44.4981C432.26 46.1643 433.35 47.7733 435.015 48.0966L435.663 48.22C436.471 48.3673 437.186 48.8309 437.65 49.5078C438.114 50.1846 438.289 51.0188 438.135 51.825C437.817 53.4957 438.914 55.1077 440.585 55.4257L446.419 56.5359"
          stroke="#1248A4"
          strokeLinecap="round"
        />
        <path
          d="M545.718 70.1777C545.718 70.1777 540.681 70.1777 540.442 63.7001C543.561 62.5022 542.121 57.9425 539.96 58.6627C537.8 59.3828 538.042 64.4202 538.042 64.4202C538.042 64.4202 537.282 64.1152 536.973 60.9664C536.807 59.3559 535.499 58.1026 533.883 58.005C528.945 57.7514 522.927 55.613 522.927 48.1066C529.261 47.978 536.429 47.989 541.698 48.0257H544.638C546.133 48.0247 547.568 48.6181 548.626 49.6753C549.683 50.7324 550.278 52.1665 550.278 53.662V54.9627C550.278 56.4575 550.872 57.8911 551.929 58.9482C552.986 60.0052 554.419 60.599 555.914 60.599H556.873C559.988 60.599 562.513 63.1241 562.513 66.239V66.4778C562.513 67.9726 563.107 69.4062 564.164 70.4632C565.221 71.5203 566.654 72.1141 568.149 72.1141C571.259 72.1141 573.781 74.6331 573.786 77.743V85.2973L543.561 84.3383"
          fill="#272D41"
        />
        <path
          d="M545.718 70.1777C545.718 70.1777 540.681 70.1777 540.442 63.7001C543.561 62.5022 542.121 57.9425 539.96 58.6627C537.8 59.3828 538.042 64.4202 538.042 64.4202C538.042 64.4202 537.282 64.1152 536.973 60.9664C536.807 59.3559 535.499 58.1026 533.883 58.005C528.945 57.7514 522.927 55.613 522.927 48.1066C529.261 47.978 536.429 47.989 541.698 48.0257H544.638C546.133 48.0247 547.568 48.6181 548.626 49.6753C549.683 50.7324 550.278 52.1665 550.278 53.662V54.9627C550.278 56.4575 550.872 57.8911 551.929 58.9482C552.986 60.0052 554.419 60.599 555.914 60.599H556.873C559.988 60.599 562.513 63.1241 562.513 66.239V66.4778C562.513 67.9726 563.107 69.4062 564.164 70.4632C565.221 71.5203 566.654 72.1141 568.149 72.1141C571.259 72.1141 573.781 74.6331 573.786 77.743V85.2973L543.561 84.3383"
          stroke="#272D41"
        />
        <path
          d="M564.912 138.07C564.912 138.07 574.267 136.149 573.547 142.865C573.308 145.985 561.312 146.224 561.312 146.224L564.912 138.07Z"
          fill="white"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M527.486 251.061L559.151 144.306C559.151 144.306 545.479 142.388 515.971 153.903C494.26 187.482 473.155 251.766 461.082 292.547L521.729 318.472L527.486 251.061Z"
          fill="white"
        />
        <path
          d="M505.294 194.444C510.925 194.444 515.49 189.879 515.49 184.248C515.49 178.617 510.925 174.052 505.294 174.052C505.084 174.052 504.879 174.052 504.669 174.074C502.097 179.218 499.584 184.656 497.1 190.318C499.023 192.914 502.063 194.445 505.294 194.444Z"
          fill="#AA90FA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M527.486 251.061L559.151 144.306C559.151 144.306 545.479 142.388 515.971 153.903C494.26 187.482 473.155 251.766 461.082 292.547L521.729 318.472L527.486 251.061Z"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M559.151 223.475L573.697 185.527C580.024 169.974 577.188 155.971 564.971 147.421C562.564 145.739 560.195 144.629 558.174 144.386L536.128 139.268L518.349 209.417C510.21 239.307 520.109 262.128 542.18 276.744C552.273 283.431 562.072 289.666 570.703 295.042L611.674 252.74L559.151 223.475Z"
          fill="white"
        />
        <path
          d="M527.038 175.111L518.349 209.417C510.21 239.307 520.109 262.128 542.18 276.744C552.273 283.431 562.072 289.666 570.703 295.042L611.675 252.74L559.133 223.475L573.679 185.527C580.006 169.974 577.17 155.971 564.953 147.421C562.546 145.739 560.177 144.629 558.156 144.386L536.11 139.268"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M527.038 175.111L518.349 209.417C512.51 230.856 515.953 248.662 526.513 262.407L524.363 288.494C524.363 288.494 502.774 275.539 506.36 246.512C509.946 217.486 527.038 175.111 527.038 175.111Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M570.787 154.38L563.343 101.21C561.835 90.4318 552.615 82.4124 541.731 82.413C530.871 82.4135 521.663 90.3999 520.127 101.152C519.943 101.152 519.759 101.152 519.568 101.152C513.143 101.141 507.805 106.103 507.348 112.512C506.89 118.921 511.469 124.591 517.83 125.493L515.13 154.406L570.787 154.38Z"
          fill="#AA90FA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M573.547 142.865C573.547 142.865 572.485 150.783 569.538 153.421C566.591 156.06 519.16 154.862 516.607 153.421C514.053 151.981 514.035 142.627 514.035 142.627H570.442"
          fill="white"
        />
        <path
          d="M573.547 142.865C573.547 142.865 572.485 150.783 569.538 153.421C566.591 156.06 519.16 154.862 516.607 153.421C514.053 151.981 514.035 142.627 514.035 142.627H570.442"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="512.852"
          y="147.906"
          width="61.6538"
          height="7.43667"
          rx="3.71834"
          fill="#2164DA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="523.169"
          y="145.746"
          width="11.5151"
          height="11.5151"
          rx="5.75754"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M528.927 88.6482L529.265 83.1956C529.346 81.9461 530.382 80.9739 531.635 80.9727H547.184C547.813 80.9727 548.417 81.2227 548.862 81.6679C549.307 82.113 549.558 82.7167 549.558 83.3462V85.7712"
          fill="#AA90FA"
        />
        <path
          d="M528.927 88.6482L529.265 83.1956C529.346 81.9461 530.382 80.9739 531.635 80.9727H547.184C547.813 80.9727 548.417 81.2227 548.862 81.6679C549.307 82.113 549.558 82.7167 549.558 83.3462V85.7712"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M543.025 126.662C543.025 126.662 554.834 127.272 560.602 115.757L543.025 126.662Z"
          fill="#AA90FA"
        />
        <path
          d="M543.025 126.662C543.025 126.662 554.834 127.272 560.602 115.757"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="544.52"
          y="145.746"
          width="2.88061"
          height="12.4741"
          rx="1.4403"
          fill="white"
        />
        <path d="M544.52 156.78V147.186V156.78Z" fill="white" />
        <path
          d="M544.52 156.78V147.186"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path d="M547.397 147.186V156.78V147.186Z" fill="white" />
        <path
          d="M547.397 147.186V156.78"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <rect
          x="560.591"
          y="145.746"
          width="2.88061"
          height="12.4741"
          rx="1.4403"
          fill="white"
        />
        <path d="M563.472 147.186V156.78V147.186Z" fill="white" />
        <path
          d="M563.472 147.186V156.78"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path d="M560.591 156.78V147.186V156.78Z" fill="white" />
        <path
          d="M560.591 156.78V147.186"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <circle cx="543.918" cy="174.174" r="10.196" fill="#AA90FA" />
        <path
          d="M514.053 64.4202H533.486V70.6664H514.053C512.33 70.6664 510.934 69.2698 510.934 67.547C510.932 66.7184 511.26 65.9231 511.845 65.3365C512.43 64.7499 513.225 64.4202 514.053 64.4202Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M544.998 62.5023L546.919 84.331L533.005 89.3683V62.7411"
          fill="#EBA687"
        />
        <path
          d="M533.005 89.3683V62.7411"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M533.005 71.7577C533.005 71.7577 536.602 72.0957 539.251 70.4166C538.516 74.495 533.005 79.176 533.005 79.176V71.7577Z"
          fill="#272D41"
        />
        <path
          d="M523.742 48H523.492C520.391 48 517.878 50.7263 517.878 54.0919V57.7661C517.911 58.5936 517.269 59.2919 516.441 59.3277C514.718 59.3277 513.322 60.8452 513.322 62.7117V62.9726C513.322 64.8427 514.718 66.3565 516.441 66.3565H530.841C530.841 66.3565 531.035 48.665 523.742 48Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <ellipse
          cx="535.522"
          cy="62.6198"
          rx="9.47588"
          ry="9.47588"
          fill="#EBA687"
        />
        <path
          d="M539.241 71.3388C535.705 72.8438 531.61 72.0642 528.874 69.3652C526.139 66.6662 525.304 62.5822 526.761 59.0264C528.219 55.4705 531.679 53.1469 535.522 53.1439"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M545.718 70.1778C545.718 70.1778 540.681 70.1778 540.442 63.7001C543.561 62.5023 542.121 57.9425 539.96 58.6627C537.8 59.3828 538.042 64.4202 538.042 64.4202C538.042 64.4202 537.282 64.1152 536.973 60.9664C536.807 59.3559 535.499 58.1026 533.883 58.005C528.945 57.7515 522.927 55.613 522.927 48.1066C529.261 47.978 536.429 47.989 541.698 48.0257H544.638C546.133 48.0247 547.568 48.6181 548.626 49.6753C549.683 50.7324 550.278 52.1665 550.278 53.662V54.9627"
          fill="#272D41"
        />
        <path
          d="M573.786 85.2899V77.743C573.787 76.2476 573.193 74.813 572.136 73.7552C571.079 72.6974 569.645 72.1031 568.149 72.1031C565.036 72.1031 562.513 69.5796 562.513 66.4668V66.2279C562.513 63.1131 559.988 60.588 556.873 60.588H555.914C552.805 60.588 550.284 58.0712 550.278 54.9627V53.662C550.278 52.1665 549.683 50.7324 548.626 49.6753C547.568 48.6181 546.133 48.0247 544.638 48.0257H541.698C536.429 47.989 529.261 47.978 522.927 48.1066C522.927 55.613 528.945 57.7515 533.883 58.005C535.499 58.1026 536.807 59.3559 536.973 60.9664C537.282 64.1152 538.042 64.4202 538.042 64.4202C538.042 64.4202 537.822 59.3718 539.96 58.6627C542.099 57.9535 543.561 62.5023 540.442 63.7001C540.681 70.1778 545.718 70.1778 545.718 70.1778L546.919 84.331"
          stroke="#272D41"
        />
        <path
          d="M530.841 83.8533C530.841 83.8533 539.718 86.0101 547.632 83.8533C548.367 86.7302 550.274 91.5288 539.957 93.6892C529.64 95.8497 529.886 90.5698 530.841 83.8533Z"
          fill="#AA90FA"
        />
        <path
          d="M530.841 83.8533C530.841 83.8533 539.718 86.0101 547.632 83.8533"
          stroke="#272D41"
        />
        <path d="M532.325 86.0027V88.6114" stroke="white" />
        <path d="M536.404 86.2416V88.8503" stroke="white" />
        <path d="M540.482 86.2416V88.8503" stroke="white" />
        <path d="M544.557 86.2416V88.8503" stroke="white" />
        <path d="M547.919 85.5214V88.1301" stroke="white" />
        <path d="M545.718 70.1777H550.278" stroke="#272D41" />
        <path
          d="M478.031 124.751L462.269 71.8421L480.816 64.0748L504.456 119.596L533.997 97.0879C543.183 90.0848 556.517 95.7541 557.843 107.236C558.498 112.892 555.873 118.427 551.079 121.5L518.808 142.189C511.902 146.618 503.339 147.615 495.6 144.891C487.861 142.166 481.811 136.024 479.203 128.245L478.031 124.751Z"
          fill="#EBA687"
        />
        <path
          d="M476.478 70.5017L467 56.5C467 55 467.5 53.5 467.5 51.5L467.941 50.2652C467.941 50.2652 478.657 57.9358 481.644 65.7252C482.497 68.7307 476.478 70.5017 476.478 70.5017Z"
          fill="#EBA687"
        />
        <path
          d="M462.662 70.8722C462.25 62.572 467.901 59.2836 467.901 59.2836L464.536 54.812C463.316 53.1913 465.416 56.0792 467 54.812L467.901 50L474.875 56.7006C477.927 59.4278 480.359 62.7781 482.007 66.5255L484.546 72.8158"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M462.779 71.5519L443.578 69.6596C442.469 69.5435 441.655 68.5662 441.74 67.4551C441.828 66.4055 442.694 65.591 443.747 65.5665L462.5 65.144L462.779 71.5519Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M460.13 68.5757L454.909 66.9885L452.396 66.2242L441.671 62.9688C440.591 62.6413 439.975 61.5064 440.289 60.4226C440.577 59.4064 441.586 58.7718 442.626 58.9529L461.126 62.223L460.13 68.5757Z"
          fill="#EBA687"
        />
        <path
          d="M454.13 66.7533L452.396 66.2242L441.671 62.9688C440.591 62.6413 439.975 61.5064 440.289 60.4226C440.577 59.4064 441.586 58.7718 442.626 58.9529L461.126 62.223L460.13 68.561"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M459.52 63.9609L441.795 56.3405C440.755 55.8997 440.263 54.7034 440.693 53.6583C441.098 52.6863 442.17 52.1749 443.181 52.4715L461.184 57.7734L459.52 63.9609Z"
          fill="#EBA687"
        />
        <path
          d="M454.707 61.8923L441.795 56.3405C440.755 55.8997 440.263 54.7034 440.693 53.6583C441.098 52.6863 442.17 52.1749 443.181 52.4715L461.184 57.7734L459.494 63.9609"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M460.663 59.5187L446.557 52.0233C445.564 51.497 445.166 50.2787 445.657 49.2676C446.12 48.3118 447.228 47.8563 448.229 48.2094L462.103 53.155L460.663 59.5187Z"
          fill="#EBA687"
        />
        <path
          d="M454.938 70.784L460.681 52.703L470.502 55.9143L476.146 65.1403L466.207 78.4337C461.757 77.5636 457.826 74.9833 455.258 71.2469L454.938 70.784Z"
          fill="#EBA687"
        />
        <path
          d="M466.258 78.5514C461.782 77.637 457.837 75.0175 455.258 71.247L454.938 70.784"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M456.956 57.6302L446.557 52.0233C445.564 51.497 445.166 50.2787 445.657 49.2676C446.12 48.3118 447.228 47.8563 448.229 48.2094L467.295 54.7863"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M484.545 72.8159L504.456 119.596L533.997 97.0879C543.182 90.0848 556.516 95.7542 557.843 107.236C558.497 112.892 555.872 118.427 551.078 121.5L518.807 142.189C511.901 146.619 503.338 147.615 495.599 144.891C487.86 142.166 481.811 136.024 479.203 128.246L478.031 124.751L464.153 77.8532"
          stroke="#272D41"
        />
        <path
          d="M163 85.0018C163.923 104.146 173.643 134.921 192.415 146.101C208.242 154.552 238.597 156.465 256.56 85.0018L216.132 81.2985L210.096 100.414"
          fill="#2164DA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M213.382 89.6394L216.129 81.2975L256.561 85.0018C255.622 88.7291 254.65 92.267 253.644 95.6154C251.062 98.5628 247.07 99.8531 243.251 98.974L213.382 89.6394Z"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M251.206 75.2063C253.198 75.7833 254.88 77.1283 255.88 78.9453C256.881 80.7622 257.119 82.9024 256.542 84.8948C255.965 86.8869 254.62 88.5681 252.803 89.5684C250.986 90.5686 248.846 90.8059 246.854 90.2279L238.203 87.7155L241.474 72.3785L251.206 75.2063Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M243.113 66.7762L238.201 87.7215L216.264 81.3687L220.945 66.4388L222.925 60.1284"
          fill="#EBA687"
        />
        <path
          d="M243.113 66.7762L238.201 87.7215L216.264 81.3687L220.945 66.4388L222.925 60.1284"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M205.801 77.8454L210.526 74.2193L212.143 61.6318C212.339 60.0433 211.742 58.4599 210.545 57.3965C209.349 56.333 207.707 55.9254 206.152 56.306L200.485 57.6447C197.394 58.3739 194.555 59.9184 192.265 62.1174L182.302 85.0209L192.907 85.187L194.306 85.0209C198.314 84.5509 201.98 82.5387 204.529 79.4108L205.801 77.8454Z"
          fill="#EBA687"
        />
        <path
          d="M182.802 88.6662C182.802 84.6662 182.302 81.6662 182.802 73.6662C183.24 66.68 184.802 66.1662 186.483 60.3366L188.657 47.9172L189.987 48.0435C192.226 48.2627 193.883 50.2239 193.725 52.4675L193.302 58.6662C193.302 58.6662 200.302 61.1662 207.343 58.7281"
          fill="#EBA687"
        />
        <path
          d="M182.802 88.6662C182.802 84.6662 182.302 81.6662 182.802 73.6662C183.24 66.68 184.802 66.1662 186.483 60.3366L188.657 47.9172L189.987 48.0435C192.226 48.2627 193.883 50.2239 193.725 52.4675L193.302 58.6662C193.302 58.6662 200.302 61.1662 207.343 58.7281"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M215.08 283.14C213.838 224.036 202.068 180.753 187.765 154.258C160.203 136.505 141.958 135.237 141.958 135.237L170.692 255.85L171.011 283.006"
          fill="white"
        />
        <path
          d="M215.08 283.14C213.838 224.036 202.068 180.753 187.765 154.258C160.203 136.505 141.958 135.237 141.958 135.237L170.692 255.85L171.011 283.006"
          stroke="#272D41"
        />
        <path
          d="M163.714 239.077L170.689 255.85L170.906 274.833C170.906 274.833 181.893 253.374 181.059 230.742C180.225 208.11 170.631 165.434 170.631 165.434L157.612 180.044L163.714 239.077Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M116 285.373L128.568 258.936L122.741 193.708C121.431 183.609 122.414 173.344 125.616 163.677L126.655 160.536L162.785 155.054C162.785 155.054 180.385 231.218 163.772 272.45C161.788 277.37 159.734 282.21 157.647 286.929"
          fill="white"
        />
        <path
          d="M116 285.373L128.568 258.936L122.741 193.708C121.431 183.609 122.414 173.344 125.616 163.677L126.655 160.536L162.785 155.054C162.785 155.054 180.385 231.218 163.772 272.45C161.788 277.37 159.734 282.21 157.647 286.929"
          stroke="#272D41"
        />
        <path
          d="M151.338 157.974C151.338 157.974 154.871 172.836 144.804 176.871C150.804 198.72 158.782 250.198 137.354 286.865"
          fill="white"
        />
        <path
          d="M151.338 157.974C151.338 157.974 154.871 172.836 144.804 176.871C150.804 198.72 158.782 250.198 137.354 286.865"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M169.114 156.134L172.03 173.705C172.282 175.227 172.111 176.788 171.535 178.219L168.177 186.603L163.194 156.757"
          fill="white"
        />
        <path
          d="M169.114 156.134L172.03 173.705C172.282 175.227 172.111 176.788 171.535 178.219L168.177 186.603L163.194 156.757"
          stroke="#272D41"
        />
        <path
          d="M194.717 283.14C197.314 223.717 175.049 155.524 175.049 155.524L194.717 283.14Z"
          fill="white"
        />
        <path
          d="M194.717 283.14C197.314 223.717 175.049 155.524 175.049 155.524"
          stroke="#272D41"
        />
        <path
          d="M204.681 281.347C205.397 221.864 180.992 154.418 180.992 154.418L204.681 281.347Z"
          fill="white"
        />
        <path
          d="M204.681 281.347C205.397 221.864 180.992 154.418 180.992 154.418"
          stroke="#272D41"
        />
        <path
          d="M181.806 282.891C186.771 230.496 170.625 165.434 170.625 165.434"
          stroke="#272D41"
        />
        <path
          d="M126.671 160.52L183.979 154.6L173.414 101.397C171.14 89.9579 160.533 82.129 148.932 83.3274C137.726 84.4849 129.086 93.7231 128.68 104.982L126.671 160.52Z"
          fill="white"
        />
        <path
          d="M126.671 160.52L194.966 154.015L173.612 98.3876C171.35 86.9471 160.532 82.1325 148.932 83.3273C137.726 84.4849 129.086 93.7231 128.68 104.982L126.671 160.52Z"
          fill="#2164DA"
        />
        <path
          d="M148.932 83.3274C137.726 84.4849 129.086 93.7232 128.68 104.982L126.671 160.52L183.979 154.6L176.589 126.198"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M155.762 82.4169L163.238 83.3465C164.117 83.4555 164.882 83.9978 165.277 84.7906L166.19 86.6276C166.409 87.0829 166.355 87.6219 166.051 88.0252C165.747 88.4285 165.244 88.6288 164.746 88.5445L158.385 87.4199L155.762 82.4169Z"
          fill="#AA90FA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M151.13 82.1614L160.935 90.9439L161.168 85.0463"
          fill="#AA90FA"
        />
        <path
          d="M151.13 82.1614L160.935 90.9439L161.168 85.0463"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M167.395 43.9387L168.775 50.2389C169.449 53.3251 166.737 56.539 162.705 57.4208L156.635 58.7498L153.874 51.9481L167.395 43.9387Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M141.261 63.903L144.159 86.4008L159.344 88.4104L153.443 61.4878"
          fill="#EBA687"
        />
        <path
          d="M159.344 88.4104L153.443 61.4878"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M141.261 63.9031L144.159 86.4008"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M155.443 70.6057C155.443 70.6057 151.878 71.743 148.839 70.6313C150.469 74.596 157.085 78.1071 157.085 78.1071L155.443 70.6057Z"
          fill="#272D41"
        />
        <circle cx="150.871" cy="61.9223" r="9.80804" fill="#EBA687" />
        <path
          d="M149.044 71.5641C152.955 72.3054 156.926 70.6099 159.096 67.2726C161.266 63.9352 161.204 59.6175 158.94 56.3435C156.676 53.0695 152.657 51.4883 148.769 52.341"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M139.239 47.06L143.712 46.0792C143.211 43.7984 144.367 41.477 146.49 40.5027C148.612 39.5285 151.126 40.1649 152.529 42.0314C152.801 38.7872 155.404 36.2295 158.653 36.0145C161.901 35.7995 164.819 37.992 165.516 41.172C165.516 41.2135 165.532 41.2551 165.538 41.2934C166.16 44.1239 165.631 47.0854 164.068 49.5259C162.506 51.9664 160.037 53.6858 157.206 54.3058L149.2 56.0598C151.098 61.2385 148.801 63.5196 148.801 63.5196C148.801 63.5196 147.842 59.1555 145.504 58.9063C143.165 58.6571 142.715 63.5835 146.143 64.1043C147.338 70.7079 142.242 71.8229 142.242 71.8229C137.498 69.7431 134.36 65.9637 132.297 62.0948C130.767 59.2251 130.67 55.805 132.033 52.8527C133.396 49.9005 136.063 47.7568 139.239 47.06Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M160.788 90.7201L159.111 88.1643C158.333 86.9608 157.067 86.1578 155.647 85.9663L143.807 84.3689C142.566 84.2845 141.436 85.0858 141.105 86.2857L141.018 86.6052C140.613 88.0833 141.283 89.6452 142.632 90.3719L147.743 93.1258C149.214 93.9193 151.047 93.4853 152.005 92.1162L153.532 89.9374C154.343 88.7799 155.88 88.3922 157.143 89.0269L160.702 90.8096C160.727 90.8168 160.754 90.8096 160.772 90.7908C160.79 90.7721 160.796 90.7449 160.788 90.7201Z"
          fill="#AA90FA"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M142.852 170.082L144.804 176.871L142.852 170.082Z"
          fill="white"
        />
        <path d="M142.852 170.082L144.804 176.871" stroke="#272D41" />
        <path
          d="M122.885 175.159L130.07 174.418L132.265 195.641C132.548 198.414 131.412 201.142 129.246 202.896L123.945 207.183"
          stroke="#272D41"
        />
        <path
          d="M154.242 157.738C154.242 157.738 175.101 223.55 148.779 286.865"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M126.677 286.865L139.626 253.866C141.236 249.766 141.852 245.343 141.424 240.959L134.677 176.622C134.313 173.168 134.612 169.676 135.559 166.335L137.3 160.172"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M126.671 174.782L127.169 171.127C127.501 168.673 128.177 166.277 129.179 164.012L130.881 160.178"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M139.143 120.116C139.622 121.365 140.102 122.588 140.584 123.777C158.04 166.878 180.458 171.868 180.458 171.868C198.135 174.945 227.566 167.268 222.275 93.7712L182.717 102.899L182.963 122.943"
          fill="#2164DA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M182.714 111.681V102.899L222.275 93.7712C222.55 97.605 222.733 101.269 222.825 104.765C221.294 108.372 217.906 110.846 214.004 111.205L182.714 111.681Z"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M139.143 120.116C139.622 121.365 140.102 122.588 140.584 123.777C158.04 166.878 180.458 171.868 180.458 171.868C198.135 174.945 227.566 167.268 222.275 93.7712L182.717 102.899L183.404 140.974"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M214.125 86.1421C216.198 86.067 218.216 86.8185 219.735 88.2313C221.254 89.6441 222.149 91.6024 222.224 93.6754C222.299 95.7481 221.547 97.7656 220.134 99.284C218.722 100.802 216.763 101.697 214.691 101.771L205.688 102.091L203.998 86.4999L214.125 86.1421Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M203.802 80.6661L205.688 102.097L182.864 102.924L182.64 87.2794L182.548 80.6661"
          fill="#EBA687"
        />
        <path
          d="M203.802 80.6661L205.688 102.097L182.864 102.924L182.64 87.2794L182.548 80.6661"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M183.152 126.975L173.621 106.218"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M195.802 83.5849C200.013 82.8692 201.802 82.1662 205.302 80.6662"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M210.83 72.2289L210.152 76.8517C209.501 78.852 208.302 79.6662 205.802 80.6662L201.302 82.1662"
          fill="#EBA687"
        />
        <path
          d="M210.83 72.2289L210.152 76.8517C209.501 78.852 208.302 79.6662 205.802 80.6662L201.302 82.1662"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M211.28 66.4016L210.762 71.8871C210.474 73.6765 209.009 75.0421 207.203 75.2033"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M211.925 61.6317L211.309 66.4239C211.111 68.3062 209.745 69.8578 207.903 70.2928"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M211.817 61.6765C211.613 63.5573 210.248 65.1064 208.408 65.5454"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M249.037 68.7144L254.143 66.0604L257.802 54.3563C258.256 52.8779 257.955 51.2708 256.996 50.0575C256.037 48.8441 254.543 48.1795 253 48.2798L247.382 48.5986C244.319 48.7717 241.358 49.763 238.807 51.4693L227.5 69.9896L232.757 74.5335L237.257 74.5335C241.149 74.7615 244.611 72.5362 247.563 69.9896L249.037 68.7144Z"
          fill="#EBA687"
        />
        <path
          d="M245.367 72.0092C240.757 74.8654 238.572 75.2296 233.566 74.8142L231.518 75.8334"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M222.476 61.0335C221.976 56.0335 224.133 51.1434 225.148 47.0058L229.3 35.1009L230.592 35.4404C232.766 36.0184 234.084 38.2215 233.567 40.4102L232.147 46.4591C243.476 51.0334 245.686 63.541 239.976 69.0334"
          fill="#EBA687"
        />
        <path
          d="M222.476 61.0335C221.976 56.0335 224.133 51.1434 225.148 47.0058L229.3 35.1009L230.592 35.4404C232.766 36.0184 234.084 38.2215 233.567 40.4102L232.147 46.4591C243.476 51.0334 245.686 63.541 239.976 69.0334"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M252.29 70.1115C251.248 71.986 249.075 72.9239 246.996 72.3958L240.607 70.7728C239.491 70.5194 238.775 69.4281 238.987 68.3033C239.188 67.2359 240.16 66.491 241.243 66.5749L253.904 65.6164L252.29 70.1115Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M254.057 65.2299C253.409 66.9689 251.662 68.0446 249.817 67.84L241.08 66.8816C239.839 66.7913 238.891 65.7354 238.936 64.4919C238.971 63.3067 239.897 62.3403 241.08 62.2555L255.683 59.8211L254.057 65.2299Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M255.712 59.8498C255.134 61.699 253.45 62.9806 251.514 63.0446L241.61 63.3641C240.366 63.4255 239.297 62.4927 239.188 61.2523C239.083 60.0766 240.831 57.7892 241.987 57.5591L257.961 52.7669L255.712 59.8498Z"
          fill="#EBA687"
        />
        <path
          d="M257.632 54.0417L255.715 59.8498C255.137 61.699 253.453 62.9806 251.517 63.0446L241.613 63.3641C240.37 63.4255 239.3 62.4927 239.192 61.2523C239.086 60.0762 239.886 59.0103 241.045 58.7827L250.75 57.1534"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M257.485 54.3439C256.974 56.099 255.414 57.343 253.59 57.4507L242.681 58.1263C241.509 58.2135 240.478 57.3577 240.347 56.1893C240.229 55.0837 242.17 53.2768 243.257 53.0335L252.318 52.1311L254.739 50.6224L257.485 54.3439Z"
          fill="#EBA687"
        />
        <path
          d="M256.257 49.5335C257.885 51.5524 258.174 52.7412 257.257 55.0335C256.257 57.5335 254.528 57.9724 252.592 58.0364L242.688 58.3559C241.444 58.4173 240.375 57.4846 240.266 56.2442C240.161 55.068 240.961 54.0021 242.119 53.7746L251.825 52.1452"
          stroke="#272D41"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6649_120955">
          <rect width="680" height="192" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
